import { type ActionReducer, type MetaReducer } from '@ngrx/store';

import { type EngineStateBase } from '@blaze-runtime/engine-data-access';

import { type AiUndoService } from '../../ai/chat/ai-undo.service';

import { executeAICommands } from './ai.actions';
import { createUndoState } from './ai.selectors';

export function createAiUndoMetaReducer(undoService: AiUndoService): MetaReducer<EngineStateBase> {
  return (reducer: ActionReducer<EngineStateBase>): ActionReducer<EngineStateBase> => {
    return (state, action) => {
      if (state && action.type === executeAICommands.type) {
        const modifiedState = reducer(state, action);
        undoService.saveState(createUndoState(state));
        return modifiedState;
      }

      return reducer(state, action);
    };
  };
}
